module.exports = __webpack_public_path__ + "static/media/1c86f5ce-d88b-49c2-8849-873cbb1f1b64.8c36a9ed.JPG";